import Vue from 'vue'
import Router from 'vue-router'
import PlayerList from './components/PlayerList'
import Document from './components/Document'
import Programming from '@/components/Programming/Programming'
import Coding from '@/components/Programming/Coding'
import Practice from '@/components/Practice'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/',
    //   name: 'home',
    //   component: Home
    // },
    {
      path: '/',
      name: 'coding',
      component: Coding
    },
    {
      path: '/',
      name: 'programming',
      component: Programming
    },
    // {
    //   path: '/battle',
    //   name: 'battle',
    //   component: Battle
    // },
    {
      path: '/practice',
      name: 'practice',
      component: Practice
    },
    {
      path: '/list',
      name: 'playerList',
      component: PlayerList
    },
    {
      path: '/document',
      name: 'document',
      component: Document
    }
  ]
})
